import Vue from 'vue';
import Vuex from 'vuex';
import contentPage from '@/store/modules/content-pages.store';
import routerStore from '@/store/modules/router.store';
import dialog from '@/store/modules/dialog.store';
import rhizome from '@/modules/Rhizome/store/rhizome.store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    contentPage,
    routerStore,
    dialog,

    rhizome,
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
} as any);
